// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"1359445a10a51ef3c7a8","303":"9de97b2d097998289ddd","495":"3eb54bee47df3bd837f3"}[chunkId] + ".js";
};